/* Iron & Acre Builder v2 — presentation only; EasyBundles retains products, cart, subscriptions and checkout. */
(function () {
  'use strict';
  var STEP_NAMES = ['Start with Protein', 'Add Produce', 'Eggs & Dairy', 'Pantry & Staples', 'Bakery'];
  var SUGGESTIONS = ['3–5 suggested', '2–3 suggested', '2–3 suggested', 'optional', 'optional'];
  var STEP_NOUNS = ['proteins', 'produce items', 'eggs & dairy items', 'pantry items', 'bakery items'];
  var FILTERS = ['All', 'Everyday', 'Quick Cooking', 'Chicken', 'Beef', 'Pork', 'Seafood', 'Steaks & Roasts'];
  /* Only the requested top-eight display priority is manual; classification uses app-provided product tags. */
  var PRIORITY = [
    /ground beef/i, /chicken breasts/i, /chicken thighs/i, /coho salmon/i,
    /burger patties/i, /ground turkey/i, /bacon pack/i, /everyday steaks/i
  ];
  /* Theme-only fallback copy keeps unfinished builder cards useful without changing live product records. */
  var CARD_COPY = {
    'Organic Pork Brats (4)': 'Flavorful pasture-raised pork brats for grilling, roasting or an easy weeknight dinner.',
    'Wild-Caught Atlantic Halibut Fillet (2 Filets) | 2 filets, 6–8 oz each': 'Wild-caught Atlantic halibut fillets with a clean, delicate flavor for roasting, grilling or pan-searing.',
    'Wild Garlic (1 Lb)': 'Fresh wild garlic with bold seasonal flavor for sauces, roasting and finishing dishes.',
    'Chef’s Herb Bundle': 'A rotating selection of fresh culinary herbs for everyday cooking.',
    'Grumpy Goat - Goat Cheese (8oz)': 'Soft, tangy goat cheese for salads, pastas and easy appetizers.',
    'Smoked Cow Cheddar (8oz)': 'Smoky cheddar with a rich, savory finish for snacking and melting.',
    'Goat Cheese Muenster (8oz)': 'A mild, creamy cheese for melting, sandwiches and everyday cooking.',
    'Garlic and Basil Butter (8oz)': 'Garlic and basil butter for vegetables, pasta, toast and finishing dishes.',
    'Tortello Pomodoro Sauce (12 oz) | 12 oz': 'A bright tomato sauce for pasta, pizza and easy pantry meals.',
    'Hand Made Italian Pasta - Tortello - 12oz - 16oz': 'Handmade Italian pasta for simple, satisfying dinners at home.',
    'Cashew Butter infused with Lions Mane': 'Creamy cashew butter with Lion’s Mane for toast, smoothies and everyday snacking.',
    "Bushel & Peck's Apple Butter (8 oz)": 'A rich apple spread for toast, oatmeal and baking.',
    "Bushel & Peck's Raspberry Jam (8 oz)": 'Fruit-forward raspberry jam for toast, yogurt and pastries.',
    "Bushel & Peck's Peach Jalapeño Jam (8 oz)": 'Sweet peach jam with a jalapeño kick for cheese boards and sandwiches.',
    "Bushel & Peck's Cherry Bomb Hot Sauce (5 oz)": 'A bold hot sauce with cherry flavor for tacos, eggs and grilled meats.',
    "Bushel & Peck's Jalapeño Lime Hot Sauce (5 oz)": 'Bright jalapeño lime hot sauce for tacos, grilled vegetables and eggs.',
    "Bushel & Peck's Belizean Habanero Hot Sauce (5 oz)": 'Fiery habanero hot sauce for tacos, eggs and grilled meats.',
    "Bushel & Peck's Garden Salsa (11.5 oz)": 'Garden salsa for chips, tacos and quick meals.',
    "Bushel & Peck's Puttanesca Sauce (24 oz)": 'Savory puttanesca sauce for quick pasta dinners and pantry meals.',
    'FlaRa Rustic Ciabatta Sourdough': 'Rustic sourdough ciabatta for sandwiches, soups and olive oil.',
    'FlaRa Sourdough Pita (4 Pack)': 'Sourdough pitas for easy pizzas, sandwiches and sharing.',
    'FlaRa Sourdough Scones': 'Fresh-baked sourdough scones for breakfast or an afternoon treat.',
    'FlaRa Sourdough Cookies': 'Fresh-baked sourdough cookies for a simple sweet finish.'
  };
  var CARD_COPY_REPLACEMENTS = {
    'Cooking Vegetables — Expanded (6)': 'A broader mix of cooking vegetables—more variety for your next delivery.',
    'Organic Pork Brats (4)': 'Flavorful pasture-raised pork brats for grilling, roasting or an easy weeknight dinner.'
  };
  var activeFilter = 'All';
  var visited = {};
  var scheduled = false;
  var drawerOpen = false;
  var priorFocus = null;
  var updateQueued = false;
  var appRoot;
  var timer;

  function app() { return window.gbb; }
  function box() {
    try { return app() && app().gbbBrowser.getRelevantBoxDataFromSessionStorage() || {}; }
    catch (error) { return {}; }
  }
  function currentStep() {
    var id = app() && app().state && app().state.currentPageId;
    var index = STEP_NAMES.findIndex(function (_, n) { return id === 'addProductsPage' + (n + 1); });
    return index < 0 ? 0 : index;
  }
  function priceCents(data) {
    var value = Number(data.total_price);
    if (Number.isFinite(value) && value >= 0) return Math.round(value);
    var displayed = document.querySelector('.gbbFooterTotalValue');
    var amount = Number((displayed && displayed.textContent || '').replace(/[^\d.]/g, ''));
    return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
  }
  function money(cents) {
    return new Intl.NumberFormat('en-US', {style:'currency', currency:'USD', maximumFractionDigits:2, minimumFractionDigits:cents%100?2:0}).format(Math.max(0,cents)/100);
  }
  function putText(element, value) {
    if (element && element.textContent !== value) element.textContent = value;
  }
  function toggleClass(element, name, shouldHave) {
    if (element && element.classList.contains(name) !== shouldHave) element.classList.toggle(name, shouldHave);
  }
  function items(data) { return Array.isArray(data.items) ? data.items : []; }
  function stepCount(data, step) {
    return items(data).filter(function (item) {
      var page = item.properties && item.properties._boxProduct;
      return page === 'addProductsPage' + (step + 1);
    }).length;
  }
  function subtotalMessage(count, cents) {
    if (!count) return 'Start adding products to build your delivery.';
    if (cents >= 15000) return 'Your delivery is ready — and delivery is complimentary.';
    if (cents >= 10000) return 'You’ve built a complete delivery.';
    return 'Your delivery is taking shape.';
  }
  function renderSummary(data) {
    var footer = document.querySelector('#gbbBundle .gbbPageFooterHTML');
    if (!footer) return;
    var count = Number(data.item_count) || items(data).reduce(function (n, item) { return n + (Number(item.quantity)||0); }, 0);
    var cents = priceCents(data);
    toggleClass(footer,'byd-v2-empty-summary',count===0);
    putText(footer.querySelector('.gbbFooterBundleSubtext'), subtotalMessage(count,cents));
    var progress = footer.querySelector('.byd-v2-progress');
    if (!progress) {
      progress = document.createElement('div'); progress.className = 'byd-v2-progress';
      progress.setAttribute('aria-live','polite');
      progress.innerHTML = '<strong class="byd-v2-current"></strong><span class="byd-v2-target"></span><div class="byd-v2-progress-track" role="progressbar" aria-label="Progress toward complimentary delivery" aria-valuemin="0" aria-valuemax="150"><span class="byd-v2-progress-fill"></span></div>';
      footer.querySelector('.gbbFooterBundleInfoContainer')?.insertAdjacentElement('afterend',progress);
    }
    putText(progress.querySelector('.byd-v2-current'), money(cents) + ' selected');
    var target = cents < 10000 ? 'Add ' + money(10000-cents) + ' more to reach the $100 order minimum.'
      : cents < 15000 ? 'Order minimum reached · Add ' + money(15000-cents) + ' more for complimentary delivery.'
      : 'Complimentary delivery unlocked.';
    putText(progress.querySelector('.byd-v2-target'),target);
    var minimumNote=progress.querySelector('.byd-v2-minimum-note');
    if (!minimumNote) {
      minimumNote=document.createElement('p');
      minimumNote.className='byd-v2-minimum-note';
      progress.appendChild(minimumNote);
    }
    var isScheduled=!!document.querySelector('#saveSubscription:checked');
    minimumNote.hidden=!isScheduled;
    if (isScheduled) putText(minimumNote,'Order minimum is calculated after subscription savings.');
    var pct = Math.min(100, Math.max(0, cents / 150));
    var fill = progress.querySelector('.byd-v2-progress-fill');
    if (fill.style.width !== pct + '%') fill.style.width = pct + '%';
    var track=progress.querySelector('[role="progressbar"]');
    if (track.getAttribute('aria-valuenow') !== String(Math.min(150,Math.floor(cents/100)))) track.setAttribute('aria-valuenow',String(Math.min(150,Math.floor(cents/100))));
    ensureMobileBar();
    var label = document.querySelector('.byd-v2-mobile-bar .byd-v2-mobile-count');
    putText(label, count + (count===1?' item':' items') + ' · ' + money(cents));
  }
  function renderSteps(data, step) {
    visited[step]=true;
    document.querySelectorAll('#gbbBundle .gbbNavigationItem').forEach(function (element, i) {
      if (i >= STEP_NAMES.length) return;
      if (element.getAttribute('role') !== 'button') element.setAttribute('role','button');
      if (element.tabIndex !== 0) element.tabIndex=0;
      element.setAttribute('aria-label','Step ' + (i+1) + ' of 5: ' + STEP_NAMES[i]);
      element.setAttribute('aria-current',i===step?'step':'false');
      toggleClass(element,'byd-v2-active',i===step);
      toggleClass(element,'byd-v2-visited',i!==step && !!visited[i]);
    });
    var wrapper=document.querySelector('#gbbBundle .gbbAddProductPageSubtextWrapper');
    if (!wrapper) return;
    var marker=wrapper.querySelector('.byd-v2-step-marker');
    if (!marker) { marker=document.createElement('div');marker.className='byd-v2-step-marker';wrapper.insertBefore(marker,wrapper.firstChild); }
    putText(marker,'Step '+(step+1)+' of 5 · '+STEP_NAMES[step]);
    var n=stepCount(data,step);
    var suggestion=wrapper.querySelector('.gbbAddProductPageSubtext');
    putText(suggestion,n ? n+' '+STEP_NOUNS[step]+' selected · '+SUGGESTIONS[step] : SUGGESTIONS[step]);
    var region=document.querySelector('#gbbBundle .gbbAddProductsContainerHTML');
    if (!region) return;
    var controls=region.querySelector('.byd-v2-nav');
    if (!controls) {
      controls=document.createElement('div');controls.className='byd-v2-nav';
      controls.innerHTML='<button type="button" class="byd-v2-back">← Back</button><button type="button" class="byd-v2-next">Next →</button>';
      region.appendChild(controls);
    }
    controls.querySelector('.byd-v2-back').hidden = step===0;
    putText(controls.querySelector('.byd-v2-next'),step===4?'Review Delivery':'Next: '+STEP_NAMES[step+1]+' →');
  }
  function tagSet(card) {
    var id = card.getAttribute('productid');
    var dataset = app() && app().state && app().state.currentProductsDataSetForVariants || {};
    var record = Object.values(dataset).find(function (v) { return String(v.product_id)===id; });
    return new Set(record && record.productTags || []);
  }
  function matches(filter,tags,title) {
    if (filter==='All') return true;
    if (filter==='Everyday') return tags.has('shop:everyday-proteins') || tags.has('shop:bacon-sausage');
    if (filter==='Quick Cooking') return tags.has('intent:quick-weeknight') || tags.has('use:quick-meals') || tags.has('shop:quick-seafood') || /burger patties|bacon pack|chicken thighs|pork chops/i.test(title);
    if (filter==='Chicken') return tags.has('protein:chicken');
    if (filter==='Beef') return tags.has('protein:beef') || /burger patties/i.test(title);
    if (filter==='Pork') return tags.has('protein:pork') || /brats|bacon/i.test(title);
    if (filter==='Seafood') return tags.has('protein:seafood') || /salmon|cod|shrimp|halibut/i.test(title);
    if (filter==='Steaks & Roasts') return tags.has('shop:steaks-roasts') || /steaks|roasts/i.test(title);
    return false;
  }
  function setDescription(container,text,replaceExisting) {
    if (!container || !text) return;
    var description=container.querySelector('.byd-v2-description');
    if (!description) {
      description=document.createElement('p');
      description.className='byd-v2-description';
    }
    if (description.textContent!==text) description.textContent=text;
    if (replaceExisting) {
      if (container.children.length!==1 || container.firstElementChild!==description) container.replaceChildren(description);
    } else if (!description.parentElement) {
      container.appendChild(description);
    }
  }
  function renderRating(stars) {
    if (!stars) return;
    var badge=stars.querySelector('[data-number-of-reviews]');
    var count=badge ? Number(badge.getAttribute('data-number-of-reviews')) : NaN;
    var noReviews=count===0 || /\bNo reviews\b|\b0 reviews\b/i.test(stars.textContent);
    toggleClass(stars,'byd-v2-no-reviews',noReviews);
    stars.hidden=noReviews;
    if (noReviews) {
      stars.setAttribute('aria-hidden','true');
      stars.querySelectorAll('[tabindex]').forEach(function (element) { element.setAttribute('tabindex','-1'); });
    } else {
      stars.removeAttribute('aria-hidden');
    }
  }
  function renderCards(step) {
    var grid=document.querySelector('#gbbBundle .gbbProductsItemsContainer');
    if (!grid) return;
    var cards=Array.from(grid.children).filter(function (card) { return card.classList.contains('gbbProductItem'); });
    cards.forEach(function (card,index) {
      var title=card.querySelector('.gbbProductItemTitle')?.textContent.trim()||'';
      var priority=step===0?PRIORITY.findIndex(function (pattern) {return pattern.test(title);}):-1;
      var order=priority>=0?priority:index+20;
      if (card.style.getPropertyValue('--byd-order')!==String(order)) card.style.setProperty('--byd-order',String(order));
      var stars=card.querySelector('.gbbReviewStarsContainer');
      renderRating(stars);
      var text=card.querySelector('.gbbProductDynamicContentContainer');
      if (CARD_COPY_REPLACEMENTS[title]) setDescription(text,CARD_COPY_REPLACEMENTS[title],true);
      else if (CARD_COPY[title] && !text?.textContent.trim()) setDescription(text,CARD_COPY[title],false);
      var variant=card.querySelector('.gbbVariantDropdownWrapper .gbbSelectedVariant');
      if (variant && variant.tabIndex!==0) {variant.tabIndex=0;variant.setAttribute('role','button');variant.setAttribute('aria-label','Choose variant for '+title);}
      var add=card.querySelector('.gbbProductAddButton');
      if (add && add.tabIndex!==0) {add.tabIndex=0;add.setAttribute('role','button');add.setAttribute('aria-label','Add '+title+' to delivery');}
    });
    var filterRow=document.querySelector('#gbbBundle .byd-v2-filters');
    if (step!==0 || !cards.length) {
      if (filterRow) filterRow.remove();
      cards.forEach(function (card) {toggleClass(card,'byd-v2-hidden',false);});
      activeFilter='All';return;
    }
    if (!filterRow) {
      filterRow=document.createElement('div');filterRow.className='byd-v2-filters';filterRow.setAttribute('role','group');filterRow.setAttribute('aria-label','Filter protein products');
      grid.insertAdjacentElement('beforebegin',filterRow);
    }
    var list=FILTERS.filter(function (filter) { return filter==='All'||cards.some(function (card) {return matches(filter,tagSet(card),card.querySelector('.gbbProductItemTitle')?.textContent.trim()||'');}); });
    if (!list.includes(activeFilter)) activeFilter='All';
    var current=Array.from(filterRow.querySelectorAll('button')).map(function (b) {return b.dataset.filter;}).join('|');
    if (current!==list.join('|')) {
      filterRow.replaceChildren();
      list.forEach(function (name) {var b=document.createElement('button');b.type='button';b.className='byd-v2-filter';b.dataset.filter=name;b.textContent=name;filterRow.appendChild(b);});
    }
    filterRow.querySelectorAll('button').forEach(function (b) {b.setAttribute('aria-pressed',b.dataset.filter===activeFilter?'true':'false');});
    cards.forEach(function (card) {toggleClass(card,'byd-v2-hidden',!matches(activeFilter,tagSet(card),card.querySelector('.gbbProductItemTitle')?.textContent.trim()||''));});
  }
  function renderChoices() {
    var one=document.querySelector('#gbbBundle .gbbSubscriptionPurchaseOption[data-purchase-type="oneTimeSubscription"]');
    var recurring=document.querySelector('#gbbBundle .gbbSubscriptionPurchaseOption[data-purchase-type="saveSubscription"]');
    [[one,'One-Time Purchase','Nothing repeats.'],[recurring,'Scheduled Delivery — Save 10%','Delivered every two weeks. Skip, swap or pause anytime.']].forEach(function (item) {
      var el=item[0]; if (!el) return;
      putText(el.querySelector('.gbbSubscriptionPurchaseOptionRadioLabel'),item[1]);
      var help=el.querySelector('.byd-v2-choice-help');
      if (!help) {help=document.createElement('p');help.className='byd-v2-choice-help';el.appendChild(help);}
      putText(help,item[2]);
    });
    scheduled=!!document.querySelector('#saveSubscription:checked');
  }
  function headerClearance() {
    var header=document.getElementById('site-header');
    if (!header) return 16;
    var rect=header.getBoundingClientRect();
    return Math.max(16,Math.ceil(Math.max(0,Math.min(window.innerHeight,rect.bottom))+12));
  }
  function renderDesktopBasket() {
    var footer=document.querySelector('#gbbBundle .gbbPageFooterHTML');
    if (!footer) return;
    var appSection=footer.closest('.shopify-section.section');
    if (appSection) appSection.classList.add('byd-v2-app-section');
    if (window.innerWidth<990) {
      footer.classList.remove('byd-v2-basket-constrained');
      footer.style.removeProperty('--byd-basket-top');
      footer.style.removeProperty('--byd-basket-height');
      footer.style.removeProperty('position');
      footer.style.removeProperty('left');
      footer.style.removeProperty('top');
      footer.style.removeProperty('width');
      footer.style.removeProperty('z-index');
      return;
    }
    var priorPosition=footer.style.getPropertyValue('position');
    if (priorPosition==='fixed') {
      footer.style.setProperty('position','static','important');
      footer.style.removeProperty('left');
      footer.style.removeProperty('top');
      footer.style.removeProperty('width');
      footer.style.removeProperty('z-index');
    }
    var bounds=footer.getBoundingClientRect();
    var top=headerClearance();
    footer.style.setProperty('--byd-basket-top',top+'px');
    footer.style.setProperty('--byd-basket-height','auto');
    var naturalHeight=footer.scrollHeight;
    var available=Math.max(260,window.innerHeight-top-16);
    var constrained=naturalHeight>available;
    footer.style.setProperty('--byd-basket-height',Math.min(naturalHeight,available)+'px');
    toggleClass(footer,'byd-v2-basket-constrained',constrained);
    var shouldPin=bounds.top<=top;
    toggleClass(footer,'byd-v2-basket-fixed',shouldPin);
    if (shouldPin) {
      footer.style.setProperty('position','fixed','important');
      footer.style.setProperty('left',Math.round(bounds.left)+'px','important');
      footer.style.setProperty('top',top+'px','important');
      footer.style.setProperty('width',Math.round(bounds.width)+'px','important');
      footer.style.setProperty('z-index','20','important');
    }
  }
  function ensureMobileBar() {
    var footer=document.querySelector('#gbbBundle .gbbPageFooterHTML');if (!footer) return;
    footer.id='byd-v2-summary';
    if (document.querySelector('.byd-v2-mobile-bar')) return;
    var backdrop=document.createElement('div');backdrop.className='byd-v2-drawer-backdrop';backdrop.setAttribute('aria-hidden','true');document.body.appendChild(backdrop);
    var close=document.createElement('button');close.type='button';close.className='byd-v2-close';close.textContent='Close ×';close.setAttribute('aria-label','Close delivery summary');document.body.appendChild(close);
    var bar=document.createElement('button');bar.type='button';bar.className='byd-v2-mobile-bar';bar.setAttribute('aria-controls','byd-v2-summary');bar.setAttribute('aria-expanded','false');bar.innerHTML='<span class="byd-v2-mobile-count">0 items · $0</span><strong>View Delivery ↑</strong>';document.body.appendChild(bar);
    bar.addEventListener('click',function () {openDrawer();});
    close.addEventListener('click',function () {closeDrawer();});
    backdrop.addEventListener('click',function () {closeDrawer();});
  }
  function openDrawer() {
    var footer=document.querySelector('#gbbBundle .gbbPageFooterHTML'); if (!footer) return;
    priorFocus=document.activeElement;drawerOpen=true;
    document.body.classList.add('byd-v2-drawer-open');
    document.querySelector('.byd-v2-mobile-bar')?.setAttribute('aria-expanded','true');
    footer.setAttribute('role','dialog');footer.setAttribute('aria-modal','true');footer.setAttribute('aria-label','Your delivery summary');
    document.querySelector('.byd-v2-close')?.focus();
  }
  function closeDrawer() {
    if (!drawerOpen) return;
    drawerOpen=false;document.body.classList.remove('byd-v2-drawer-open');
    document.querySelector('.byd-v2-mobile-bar')?.setAttribute('aria-expanded','false');
    var footer=document.querySelector('#gbbBundle .gbbPageFooterHTML');footer?.removeAttribute('role');footer?.removeAttribute('aria-modal');footer?.removeAttribute('aria-label');
    if (priorFocus&&priorFocus.isConnected) priorFocus.focus();
  }
  function render() {
    var root=document.getElementById('gbbBundle'); if (!root) return;
    var data=box(); var step=currentStep();
    renderSummary(data);renderSteps(data,step);renderCards(step);renderChoices();renderDesktopBasket();
  }
  function schedule() {
    if (updateQueued) return;
    updateQueued=true;
    window.requestAnimationFrame(function () {updateQueued=false;render();});
  }
  document.addEventListener('click',function (event) {
    var filter=event.target.closest('.byd-v2-filter');
    if (filter) {activeFilter=filter.dataset.filter;schedule();return;}
    if (event.target.closest('.byd-v2-back,.byd-v2-next')) {
      var step=currentStep(),forward=!!event.target.closest('.byd-v2-next');
      if (forward && step===4) {if (window.innerWidth<990) openDrawer();else document.querySelector('#gbbBundle .gbbPageFooterHTML')?.scrollIntoView({block:'nearest',behavior:'smooth'});return;}
      document.getElementById('addProductsPage'+(step+(forward?2:0)))?.click();
      window.setTimeout(schedule,150);return;
    }
    var add=event.target.closest('.gbbProductAddButton');
    if (add) {
      var card=add.closest('.gbbProductItem'),choice=card?.querySelector('.gbbVariantDropdownWrapper .gbbSelectedVariant');
      if (choice && !choice.getAttribute('data-variant-id')) {
        event.preventDefault();event.stopImmediatePropagation();toggleClass(choice,'byd-v2-required',true);
        var hint=card.querySelector('.byd-v2-variant-hint');
        if (!hint) {hint=document.createElement('div');hint.className='byd-v2-variant-hint';choice.insertAdjacentElement('afterend',hint);}
        putText(hint,'Choose a variant before adding.');choice.click();choice.focus();return;
      }
    }
    if (event.target.closest('.gbbVariantOption')) {var card2=event.target.closest('.gbbProductItem');toggleClass(card2?.querySelector('.gbbSelectedVariant'),'byd-v2-required',false);card2?.querySelector('.byd-v2-variant-hint')?.remove();}
    if (event.target.closest('.gbbNavigationItem,.gbbFooterNextButton,.gbbFooterBackButton,.gbbProductAddButton,.gbbFooterClearItemsButtonWrapper,.gbbFooterProductsContainer')) {
      window.setTimeout(schedule,100);window.setTimeout(schedule,550);
    }
  },true);
  document.addEventListener('change',function (event) {if (event.target.matches('input[name="purchaseOption"]')) {window.setTimeout(schedule,150);window.setTimeout(schedule,600);}},true);
  document.addEventListener('keydown',function (event) {
    if (event.key==='Escape'&&drawerOpen) {closeDrawer();return;}
    if (drawerOpen && event.key==='Tab') {
      var footer=document.querySelector('#gbbBundle .gbbPageFooterHTML');
      var els=[document.querySelector('.byd-v2-close')].concat(Array.from(footer?.querySelectorAll('button,input,select,a[href],[role="button"]')||[])).filter(function (e) {return e&&e.getBoundingClientRect().width>0;});
      var i=els.indexOf(document.activeElement);if (event.shiftKey&&i<=0) {event.preventDefault();els[els.length-1]?.focus();}
      else if (!event.shiftKey&&i===els.length-1) {event.preventDefault();els[0]?.focus();}
    }
    if (event.key!=='Enter' && event.key!==' ') return;
    var el=event.target.closest('.gbbNavigationItem,.gbbSelectedVariant,.gbbProductAddButton');
    if (el) {event.preventDefault();el.click();}
  });
  document.addEventListener('gbb-footer-rendered',schedule);
  document.addEventListener('gbb-next-button-click',function () {window.setTimeout(schedule,100);});
  window.addEventListener('resize',schedule,{passive:true});
  window.addEventListener('scroll',schedule,{passive:true});
  function start() {
    appRoot=document.getElementById('gbbBundle'); if (!appRoot) return false;
    new MutationObserver(schedule).observe(appRoot,{childList:true,subtree:true,characterData:true});
    schedule();
    timer=window.setInterval(schedule,950);
    return true;
  }
  if (!start()) {
    var tries=0,wait=window.setInterval(function () {tries++;if(start()||tries>80) window.clearInterval(wait);},250);
  }
  window.addEventListener('pagehide',function () {window.clearInterval(timer);});
})();
